/*
 * routers
 *
 */
import {BasicLayout, BasicLogin, Profile} from "@/layout"

import {Ads, Agent, Bidding, Ent, LongTailSearch, Manager, Product} from "@/view/Pages"

import {AdsSetting, Info, LongtailSetting, Tagset, Upload} from "@/view/User"

import {Login, Logout, Register, Wechat} from "@/view/Login"

import {Help, UserAgreement} from '@/view/Utils'

import Redirect from "@/view/Redirect.vue"

const config = 
{
    path: "/",
    name: "home",
    product: "爱助手", 
    version: "营销版", //-β"
    company: "仝睿科技", 
    meta: { title: "仝睿科技" },
    component: BasicLayout,
    redirect: "/redirect",
    children: [
        {
            path: "/redirect",
            name: "redirect",
            meta: { title: "路由选择", show: false},
            permission: {"user": true, "agent": true, "manager": true },
            component: Redirect 
        },
        {
            path: "/index",
            name: "index",
            meta: { title: "今日推荐", show: false },
            permission: {"user": true, "agent": true, "manager": true }
        },
        {
            path: "/agent",
            name: "agent",
            meta: { title: "用户", show: true },
            permission: {"user": false, "agent": true, "manager": false },
            component: Agent
        },
        {
            path: "/ent",
            name: "ent",
            meta: { title: "获客", show: true, belowicon: "compass"},
            permission: {"user": true, "agent": false, "manager": false},
            component: Ent
        },
        {
            path: "/bid",
            name: "bid",
            meta: { title: "标讯", show: true, belowicon: "bell"},
            permission: {"user": true, "agent": false, "manager": false},
            component: Bidding
        },
	    {
            path: '/ltl',
            name: 'ltl',
            meta: { title: "长尾", show: true, belowicon: "line-chart"},
            permission: {"user": true, "agent": false, "manager": false},
            component: LongTailSearch
        },
        {
            path: "/ads",
            name: "ads",
            meta: { title: "推广", show: true, belowicon: "sound"},
            permission: {"user": true, "agent": false, "manager": false},
            component: Ads
        },
        {
            path: "/man",
            name: "man",
            meta: { title: "代理", show: true },
            permission: {"user": false, "agent": false, "manager": true},
            component: Manager
        },
        {
            path: "/pro",
            name: "pro",
            meta: { title: "产品", show: true },
            permission: {"user": false, "agent": false, "manager": true},
            component: Product
        },
        {
            path: "/uc",
            name: "uc",
            meta: { title: "username", show: true , belowicon: "user", store: "getUsername", "float": "right" },
            permission: {"user": true, "agent": true, "manager": true},
            avatar: { icon: "user", store: "getUIcon" },
            component: Profile,
            redirect: "/uc/info",
            children: [
                {
                    path: "/uc/info",
                    name: "info",
                    meta: { title: "用户信息", show: true, icon: "user" },
                    permission: {"user": true, "agent": true, "manager": true },
                    component: Info
                },
                {
                    path: "/uc/tag",
                    name: "tag",
                    meta: { title: "标签定制", show: true , icon: "tag" },
                    permission: {"user": true, "agent": false, "manager": false},
                    component: Tagset
                },
                {
                    path: "/uc/upld",
                    name: "upld",
                    meta: { title: "数据上传", show: true , icon: "upload" },
                    permission: {"user": true, "agent": false, "manager": false},
                    component: Upload
                },
                {
                    path: "/uc/ltls",
                    name: "ltls",
                    meta: { title: "长尾主题", show: true, icon: "line-chart"},
                    permission: {"user": true, "agent": false, "manager": false},
                    component: LongtailSetting
                },
                {
                    path: "/uc/adsp",
                    name: "adsp",
                    meta: { title: "推广配置", show: true , icon: "sound" },
                    permission: {"user": true, "agent": false, "manager": false},
                    component: AdsSetting
                },
                {
                    path: "/uc/help",
                    name: "help",
                    meta: { title: "使用帮助", show: true , icon: "question-circle" },
                    permission: {"user": true, "agent": true, "manager": true },
                    component: Help 
                },
                {
                    path: "/uc/logout",
                    name: "logout",
                    meta: { title: "登录注销", show: true , icon: "logout" },
                    permission: {"user": true, "agent": true ,"manager": true },
                    component: Logout
                }        
            ]
        }
    ]
};

config.meta.title = config.product + "-" + config.version + "-" + config.company; 

const user = 
{
    path: "/user",
    component: BasicLogin,
    redirect: "/user/login",
    children: [
      {
        path: "login",
        name: "login",
        component: Login
      },
      {
        path: "wechat",
        name: "wechat",
        component: Wechat
      },
      {
        path: "reg",
        name: "reg",
        component: Register
      },
      {
        path: 'ua',
        name: 'ua',
        component: UserAgreement 
      }
    ]
}

const whiteList = ["/user/login", "/user/wechat", "/user/reg", "/user/ua"];

const relations = {
  "ent": [
     {
       name: "客户",
       task: "ENT_TO_ENT",
       tab: "ent",
       field: "entnames"
     },
     {
       name: "标讯",
       task: "ENT_TO_BIDDING",
       tab: "bid",
       field: "entnames"
     }
  ],
  "bid": [
     {
       name: "客户",
       task: "BIDDING_TO_ENT",
       tab: "ent",
       field: "bid_id"
     },
     {
       name: "标讯",
       task: "BIDDING_TO_BIDDING",
       tab: "bid",
       field: "bid_id"
     }
  ],
  "ads": [
      {
       name: "推广",
       task: "NEWS_TO_NEWS",
       tab: "news",
       field: "news_id"
      },        
      {
       name: "客户",
       task: "NEWS_TO_ENT",
       tab: "ent",
       field: "news_id"
      }
  ]
}

////////////////////////////////////////////////////////////////////////////////////
//the prefix for backend APIs. Valid values include dev, stg, or "", 
//used to differentiate API services for development/staging/production environments
const BACKEND_API_PREFIX = "/prd/"; 

//the target platform for which the packages will be built
//valid values include app and web
const TARGET_PLATFORM = "web"; 

//the share link host URL 
const SHARE_LINK_HOST = "wx.alonger.cn"; 

export {config, user, whiteList, relations, BACKEND_API_PREFIX, SHARE_LINK_HOST, TARGET_PLATFORM};
